module.exports = __webpack_public_path__ + "img/7.034adfe7.jpg";